import PropTypes from 'prop-types';
import React from 'react';
import map from 'lodash/map';
import Option from './option';

const ViewOptions = ({ currentView, config, onOptionClick }) => {
  const options = map(config, (viewConfig, key) => (
    <Option
      key={key}
      currentView={currentView}
      onClick={onOptionClick}
      {...viewConfig}
    />
  ));

  return (
    <div className="o-flexbox__item">
      <div className="c-form-input-group">
        {options}
      </div>
    </div>
  );
};

ViewOptions.propTypes = {
  currentView: PropTypes.string.isRequired,
  config: PropTypes.object,
  onOptionClick: PropTypes.func.isRequired,
};

export default ViewOptions;
